import { ScaleLinear } from 'd3-scale'
import { VerticalTick } from './verticalTick'
import React from 'react'
import './styles.scss'
interface Props {
  values: number[]
  x: ScaleLinear<number, number>
  y: ScaleLinear<number, number>
  format: (a: number) => string
  textAnchor?:
    | ((a: number, i: number, arr: number[]) => 'start' | 'end' | 'middle')
    | 'start'
    | 'end'
    | 'middle'
}

export const VerticalTicks = ({
  values,
  x,
  y,
  format,
  textAnchor = (a, i, arr) => 'middle'
}: Props) => {
  return (
    <>
      {values.map((m, i) => {
        return (
          <VerticalTick
            key={i}
            y={y.range() as [number, number]}
            x={x(m)}
            val={m}
            hideLabel={false}
            textAnchor={
              typeof textAnchor === 'string'
                ? textAnchor
                : textAnchor(m, i, values)
            }
            format={format}
          />
        )
      })}
    </>
  )
}
